import React, { Component } from 'react';
import NavButton from '../component/NavButton.js';

export default class LovAdminNav extends Component{
	constructor(props){
		super(props);
		this.handleEmployeeHover = this.handleEmployeeHover.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.handleThankyouHover = this.handleThankyouHover.bind(this);
		this.state = {employeeHover:false,thankyouHover:false,employeeClicked:false,thankyouClicked:false,current:'Home'};
	}
	
	handleEmployeeHover(){ //method for handling mouse hover over "Employee" button, display dropdown buttons
		if(this.state.employeeClicked !== true){
			this.setState({employeeHover:!this.state.employeeHover});
		}
	}

	handleThankyouHover(){ //method for handling mouse hover over "Thankyous" button, display dropdown buttons
		if(this.state.thankyouClicked !== true){
			this.setState({thankyouHover:!this.state.thankyouHover});
		}
	}

	handleClick(name,type){ //method that handles user click on a nav button,passes info up to main in order to handle navigation
		this.props.navClick(this.state.current,name);
		this.setState({current:name});
	}

	render(){
		const divStyle = "fl w-33 ma0 bl b--white adminNavDiv pl1 pr1";
		const buttonstyle = "dim b w-100 center pt2 pb2 bn white bg-navy navOverflow pointer";
		const hoverButtonstyle = "b w-100 center pt2 pb2 bn white bg-navy navOverflow";
		const dropstyle = "b fl w-100 dark-blue bg-white pa1 grow b--dark-blue pt2 pb2 bb bl br bt0 pointer dib";
		const dropend = "b fl w-100 dark-blue bg-white pa1 grow b--dark-blue pt2 pb2 bb bl br bt0 pointer dib br--bottom br3";
		const thankyous = <div className="z-1 absolute shadow-3 br--bottom br3 adminDropDiv">
							<div className="bb b--blue mb3">
								<NavButton name="Create" onClick={this.handleClick} type="thankyoudrop" styles={dropstyle}/>
							</div>
							<div className="bb b--blue mb3">
								<NavButton name="Mass" onClick={this.handleClick} type="thankyoudrop" styles={dropstyle}/>
							</div>
						  		<NavButton name="Pending" onClick={this.handleClick} type="thankyoudrop" styles={dropend}/>
						  </div>;

		const employees = <div className="z-1 absolute shadow-3 br--bottom br3 adminDropDiv">
							<NavButton name="Add" onClick={this.handleClick} type="employeedrop" styles={dropstyle}/>
						  	<NavButton name="View" onClick={this.handleClick} type="employeedrop" styles={dropstyle}/>
						  	<NavButton name="Email" onClick={this.handleClick} type="employeedrop" styles={dropend}/>
						  </div>;
		return(
			<div className="mt0 mb0 fl w-100 bg-navy">
				<div className="fl w-50">
					<div className="fl w-33 ma0">
						<NavButton name="Home" onClick={this.handleClick} styles={buttonstyle} type="button"/>
					</div>
					<div className={divStyle}>
						<NavButton name="Admin Center" onClick={this.handleClick} styles={buttonstyle} type="button"/>
					</div>
					<div className={divStyle}>
						<NavButton name="Prize Requests" onClick={this.handleClick} styles={buttonstyle} type="button"/>
					</div>
				</div>
				<div className="fl w-50">
					<div className={divStyle}>
						<div onMouseEnter={this.handleEmployeeHover} onMouseLeave={this.handleEmployeeHover} className="overflow-hidden">
							<NavButton name="Employees" styles={hoverButtonstyle} type="button"/>
							{this.state.employeeHover && employees}
						</div>
					</div>
					<div className={divStyle}>						
						<div onMouseEnter={this.handleThankyouHover} onMouseLeave={this.handleThankyouHover} className="overflow-hidden">
							<NavButton name="Thank yous" styles={hoverButtonstyle} type="button"/>
							{this.state.thankyouHover && thankyous}
						</div>
					</div>
					<div className={divStyle}>
						<button onClick={this.props.logout} className={buttonstyle}>Logout</button>
					</div>
				</div>
			</div>	
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/LovAdminNav.js